const SearchBar = ({ searchValue, placeholder, searchFunction }) => {
  return (
    <div className="relative h-10">
      <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
        <i className="far fa-search text-gray-400" />
      </div>
      <input
        type="text"
        className="block w-full h-full rounded-lg border border-gray-300 bg-white pl-10 pr-4 text-sm text-gray-900 placeholder:text-gray-400 focus:border-primary-500 focus:outline-none focus:ring-1 focus:ring-primary-500"
        onChange={(text) => searchFunction(text.target.value)}
        placeholder={placeholder}
        value={searchValue}
      />
    </div>
  );
};

export default SearchBar;
